import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer } from 'react-router-redux';
import createSagaMiddleware from 'redux-saga';

import photographerReducer from './photographers/reducer';
import timelineReducer from './timeline/reducer';
import searchReducer from './search/reducer';
import lightboxReducer from './lightbox/reducer';

import fotolaugetSaga from './sagas';
import App from './App';

import PageWrapper from './components/PageWrapper';
import FrontPage from './pages/FrontPage';
import Photographer from './pages/Photographer';
import PhotographerList from './pages/PhotographerList';
import PricingList from './pages/PricingList';

export const BASE_URL = window.location.href.includes('localhost')
  ? 'http://www.mrfl.no'
  : '';

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = applyMiddleware(sagaMiddleware);
const store = createStore(
  combineReducers({
    routing: routerReducer,
    photographers: photographerReducer,
    timeline: timelineReducer,
    search: searchReducer,
    lightbox: lightboxReducer,
  }),
  composeEnhancers(middleware),
);

sagaMiddleware.run(fotolaugetSaga);

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Route path="/" component={App}>
        <IndexRoute component={FrontPage} />
        <Route component={PageWrapper}>
          <Route path="/priser/" component={PricingList} />
          <Route path="/fotografer/" component={PhotographerList} />
          <Route path="/fotografer/:id" component={Photographer} />
        </Route>
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js